// Latency display shared by the output panel and the PDF. Figures are model
// estimates (typically ~40-50% off against benchmarks), so they are shown to
// two significant figures.
import type { CalculationResult, TimeValue } from "@/types/calculator";

type Time = number | TimeValue;

export function approxTime(t: Time, fallbackUnit = "ms"): string {
  const { value, unit } = typeof t === "object" && t !== null ? t : { value: t as number, unit: fallbackUnit };
  const rounded = Number(value.toPrecision(2));
  return `~${rounded.toLocaleString(undefined, { maximumFractionDigits: 3 })} ${unit}`;
}

export function lowConfidenceNote(result: CalculationResult): string | null {
  return result.otherParameters.lowConfidence
    ? "Rough estimate: this is a mixture-of-experts model, where the latency model can be several times off."
    : null;
}
